import { render } from "./CurriculumList.vue?vue&type=template&id=1f552afe&scoped=true"
import script from "./CurriculumList.vue?vue&type=script&lang=js"
export * from "./CurriculumList.vue?vue&type=script&lang=js"

import "./CurriculumList.vue?vue&type=style&index=0&id=1f552afe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f552afe"]])

export default __exports__